import { RootState } from 'store/root-reducer';
import { SettingsError, SettingsResponse } from './types';

const selectSystemSettings = (state: RootState) => state.admin?.systemSettings;

export const getResult = (state: RootState): SettingsResponse | null =>
  selectSystemSettings(state)?.settingsResult ?? null;

export const getSettingsLoading = (state: RootState): boolean => !!selectSystemSettings(state)?.isGetSettingsLoading;

export const updateSettingsLoading = (state: RootState): boolean =>
  !!selectSystemSettings(state)?.isUpdateSettingsLoading;

export const settingsError = (state: RootState): SettingsError | null =>
  selectSystemSettings(state)?.settingsError ?? null;
